module.exports = __webpack_public_path__ + "static/media/ethereumFoundation.7c62cc70.png";